module.exports = __webpack_public_path__ + "img/yano_Q_400_15_8.0888fb75.png";